import styled from 'styled-components';

interface WrapperProps {
  paddingless?: boolean;
  isMobileView?: boolean;
}
const ContentWrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.module};
  border-radius: ${({ theme }) => theme.rounds.moduleRound};
  padding: ${({ theme, paddingless, isMobileView }) =>
    isMobileView ? theme.spacings.spacing8 : paddingless ? 0 : theme.spacings.spacing24};
`;

export default ContentWrapper;
